import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GetBulkPaymentHistory } from '@app/finxone-web-frontend/app/lib/actions/bulk-payment-history.action';
import { UpdateFormDataActionWithId } from '@app/finxone-web-frontend/app/lib/actions/form-submission.action';
import {
  BulkPaymentHistoryResponse,
  BulkPaymentHistoryResult,
} from '@app/finxone-web-frontend/app/lib/services/account-service/account.type';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { AccountState } from '@app/finxone-web-frontend/app/lib/state/account.state';
import { BulkPaymentHistoryState } from '@app/finxone-web-frontend/app/lib/state/bulk-payment-history.state';
import { ProfileState } from '@app/finxone-web-frontend/app/lib/state/user-profile.state';
import { FormActionTypeEnum } from '@finxone-platform/form-action';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import {
  Columns,
  ProviderClass,
  SystemRole,
  UiZoneWidgetAttributeConfig,
  ZoneActionOptions,
  baseCssConfigStyle,
} from '@finxone-platform/shared/sys-config-types';
import { Select, Store } from '@ngxs/store';
import { Observable, Subject, first, map, takeUntil } from 'rxjs';
import { BaseComponent } from '../base/base.component';
@Component({
  standalone: false,
  selector: 'finxone-web-frontend-bulk-payment-history-listing',
  templateUrl: './bulk-payment-history-listing.component.html',
})
export class BulkPaymentHistoryListingComponent extends BaseComponent implements OnInit {
  actionOptions: ZoneActionOptions[] = [{ label: 'View Payment', value: 'view-payment', isIdNotExist: '' }];
  @Select(BulkPaymentHistoryState.getBulkPaymentHistory)
  paymentHistory!: Observable<any>;
  public paymentHistoryData: BulkPaymentHistoryResult[] = [];
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  public pageNumber = 1;
  public textStyle: baseCssConfigStyle;
  public columns: Columns[] = [];
  public entityName: string;
  public isShowOption: boolean = false;
  public isShowMoreOption = false;
  public totalListCount = 10;
  public tableHeaderColumns: any;
  public isClickMenuIcon = false;
  public menuPopupCss = {};
  private searchText: string = '';
  constructor(
    public store: Store,
    public dataIn: ProviderClass<UiZoneWidgetAttributeConfig>,
    private router: Router,
    private configService: ConfigService,
  ) {
    super();
    this.getPageData();
  }

  ngOnInit() {
    this.isShowMoreOption = true;
    this.menuPopupCss = {
      border: 'none',
      'padding-right': '6rem',
      'box-shadow': `0px 2px 12px 0px rgba(0, 0, 0, 0.1)`,
    };
  }

  public get pageSize(): number {
    if (this.dataIn.attri['pageSize'] != null) return Number(this.dataIn.attri['pageSize']);
    else return 10;
  }

  public get pagingEnabled(): boolean {
    if (this.dataIn.attri['pagingEnabled'] != null) return this.dataIn.attri['pagingEnabled'];
    else return true;
  }

  handleScroll() {
    if (this.pagingEnabled) {
      if (this.pageNumber * this.pageSize === this.paymentHistoryData?.length) {
        this.pageNumber = this.pageNumber + 1;
        this.store.dispatch(new GetBulkPaymentHistory(this.pageNumber, this.pageSize));
      }
    }
  }
  @HostListener('scroll', ['$event'])
  onScroll(event: Event) {
    const el = event.target as HTMLElement;
    const scrollPerc = (el.scrollTop / (el.scrollHeight - el.clientHeight)) * 100;
    if (scrollPerc > 80) {
      this.handleScroll();
    }
  }

  onPageChange(event: { first: number; page: number; pageCount: number; rows: number }) {
    this.pageNumber = event.first / event.rows + 1;
    this.dataIn.attri['pageSize'] = event.rows;
    this.store.dispatch(new GetBulkPaymentHistory(this.pageNumber, this.pageSize, this.searchText));
  }

  public getPageData() {
    this.store.dispatch(new GetBulkPaymentHistory(this.pageNumber, this.pageSize));
    this.paymentHistory
      .pipe(
        takeUntil(this.destroy$),
        map((listEntity: BulkPaymentHistoryResponse) => {
          this.paymentHistoryData = [];
          this.totalListCount = listEntity?.totalItems;
          this.paymentHistoryData = listEntity.result;
        }),
      )
      .subscribe();
  }

  public performAction(event: { actionKey: string; actionId: string }) {
    this.store.dispatch(
      new UpdateFormDataActionWithId(
        {
          masterFileId: event.actionId,
        },
        FormActionTypeEnum.BULK_PAYMENTS,
      ),
    );

    let activeUserType = '';
    let activeUser: SystemRole;
    const profile = this.store.selectSnapshot(ProfileState.getProfile);
    this.configService
      .getRoles()
      .pipe(
        first(),
        map((roles) => {
          Object.entries(roles).forEach(([roleKey, value]) => {
            if (roleKey === profile.activeRole) {
              activeUser = value;
            }
          });
          if (activeUser?.userType) {
            activeUserType = activeUser.userType;
          }
        }),
      )
      .subscribe();
    const systemConfig = this.store.selectSnapshot(AccountState.getPaymentGatewayConfig);
    let pageRedirectUrl = '/zones/payments/bulk-payment-summary-elaborated-view';
    if (systemConfig?.paymentRequest?.enabled && activeUserType === 'org') {
      pageRedirectUrl = '/zones/payments/bulk-payment-summary-elaborated-view-approver-reject';
    }
    this.router.navigate([pageRedirectUrl]);
  }

  public searchValue(searchText: string) {
    this.searchText = searchText;
    this.pageNumber = 1;
    this.store.dispatch(new GetBulkPaymentHistory(this.pageNumber, this.pageSize, searchText));
  }
}
